import { useCallback } from "react";
import { preloadImage } from "../utils/fileUtils";

interface UsePreviewHandlersProps {
  setPreviewVisible: (visible: boolean) => void;
  setPreviewImage: (image: string) => void;
  setVideoVisible: (visible: boolean) => void;
  setCurrentVideo: (video: string) => void;
  setFileVisible: (visible: boolean) => void;
  setCurrentFile: (file: string) => void;
}

export const usePreviewHandlers = ({
  setPreviewVisible,
  setPreviewImage,
  setVideoVisible,
  setCurrentVideo,
  setFileVisible,
  setCurrentFile,
}: UsePreviewHandlersProps) => {
  // 优化预览处理
  const handlePreview = useCallback(
    (image: string) => {
      preloadImage(image);
      setPreviewImage(image);
      setPreviewVisible(true);
    },
    [setPreviewImage, setPreviewVisible]
  );

  // 优化取消预览
  const handleCancel = useCallback(() => {
    setPreviewVisible(false);
  }, [setPreviewVisible]);

  // 视频预览处理
  const handleVideoPreview = useCallback(
    (videoUrl: string) => {
      setCurrentVideo(videoUrl);
      setVideoVisible(true);
    },
    [setCurrentVideo, setVideoVisible]
  );

  // 取消视频预览
  const handleVideoCancel = useCallback(() => {
    setVideoVisible(false);
  }, [setVideoVisible]);

  // 文件预览处理
  const handleFilePreview = useCallback(
    (fileUrl: string) => {
      setCurrentFile(fileUrl);
      setFileVisible(true);
    },
    [setCurrentFile, setFileVisible]
  );

  // 取消文件预览
  const handleFileCancel = useCallback(() => {
    setFileVisible(false);
  }, [setFileVisible]);

  return {
    handlePreview,
    handleCancel,
    handleVideoPreview,
    handleVideoCancel,
    handleFilePreview,
    handleFileCancel,
  };
};

